// extracted by mini-css-extract-plugin
export default {"inputWrapper":"input-with-submit_inputWrapper__aee96"};